import { ADD_TAG_ASSOCIATION, REMOVE_PENDING_ADDITION_TAG_ASSOCIATION, REMOVE_PENDING_DELETION_TAG_ASSOCIATION, REMOVE_TAG_ASSOCIATION, SET_PENDING_ADDITION_TAG_ASSOCIATIONS, SET_PENDING_DELETION_TAG_ASSOCIATIONS, SET_TAG_INPUT, SET_TAG_SUGGESTIONS } from '@instructure/quiz-common';
export var addTagAssociation = function addTagAssociation(entityType, entityId, tagAssociation) {
  return {
    type: ADD_TAG_ASSOCIATION,
    payload: {
      entityType: entityType,
      entityId: entityId,
      tagAssociation: tagAssociation
    }
  };
};
export var removePendingAdditionTagAssociation = function removePendingAdditionTagAssociation(entityType, entityId, tagValue) {
  return {
    type: REMOVE_PENDING_ADDITION_TAG_ASSOCIATION,
    payload: {
      entityType: entityType,
      entityId: entityId,
      tagValue: tagValue
    }
  };
};
export var removePendingDeletionTagAssociation = function removePendingDeletionTagAssociation(entityType, entityId, tagAssociationId) {
  return {
    type: REMOVE_PENDING_DELETION_TAG_ASSOCIATION,
    payload: {
      entityType: entityType,
      entityId: entityId,
      tagAssociationId: tagAssociationId
    }
  };
};
export var removeTagAssociation = function removeTagAssociation(entityType, entityId, tagAssociationId) {
  return {
    type: REMOVE_TAG_ASSOCIATION,
    payload: {
      entityType: entityType,
      entityId: entityId,
      tagAssociationId: tagAssociationId
    }
  };
};
export var setPendingAdditionTagAssociations = function setPendingAdditionTagAssociations(entityType, entityId, tags) {
  return {
    type: SET_PENDING_ADDITION_TAG_ASSOCIATIONS,
    payload: {
      entityType: entityType,
      entityId: entityId,
      tags: tags
    }
  };
};
export var setPendingDeletionTagAssociations = function setPendingDeletionTagAssociations(entityType, entityId, tags) {
  return {
    type: SET_PENDING_DELETION_TAG_ASSOCIATIONS,
    payload: {
      entityType: entityType,
      entityId: entityId,
      tags: tags
    }
  };
};
export var setTagInput = function setTagInput(entityType, entityId, tagInput) {
  return {
    type: SET_TAG_INPUT,
    payload: {
      entityType: entityType,
      entityId: entityId,
      tagInput: tagInput
    }
  };
};
export var setTagSuggestions = function setTagSuggestions(entityType, entityId, tags, text) {
  return {
    type: SET_TAG_SUGGESTIONS,
    payload: {
      entityType: entityType,
      entityId: entityId,
      tags: tags,
      text: text
    }
  };
};